module.exports = __webpack_public_path__ + "img/stock0.ecbf63d5.png";